import React, { useEffect, useRef } from 'react';
import FJValueInput from '../FJValueInput/FJValueInput';
import styles from './FJSliderSet.module.less';
import FJUtil from '../../../util/FJUtil';
import FJDropDownManager from '../../js/FJDropDownManager';
import FJSlider from '../FJSlider/FJSlider';
import FJConstant from '../../../constants/FJConstant';
import classNames from 'classnames';

const limitInfo = {
    width: {
        min: 1,
        max: 100,
    },
    blur: {
        min: 0,
        max: 100,
    },
    offset: {
        min: 0,
        max: 100,
    },
    direction: {
        min: 0,
        max: 360,
    },
    opacity: {
        min: 0,
        max: 100,
    },
};

const FJSliderSet = props => {
    const {
        text,
        value,
        name,
        onChange,
        min,
        max,
        defaultValue,
        mouseDownHideDropDown = true,
        className,
        labelClassName,
        digits,
    } = props;

    // const sliderRef = useRef(null);
    //
    // useEffect(() => {
    //     if (value === '') {
    //         sliderRef.current.updateSlider && sliderRef.current.updateSlider(defaultValue);
    //     } else {
    //         sliderRef.current.updateSlider && sliderRef.current.updateSlider(value);
    //     }
    // }, [value, defaultValue]);

    /**
     * @description 处理slider事件
     * @param event
     * @param attribute
     * @private
     */
    const _handleSliderEvent = (value, type) => {
        switch (type) {
            case 'mousemove':
                _changeAttribute(value, name, FJConstant.CHANGE);
                break;
            case 'mousedown':
                _changeAttribute(value, name, FJConstant.CHANGE_START);
                break;
            case 'mouseup':
                _changeAttribute(value, name, FJConstant.CHANGE_END);
                break;
            default:
                break;
        }
    };

    /**
     * @description 属性值修改
     * @param value
     * @param attribute
     * @param type 'changeStart', 'change', 'changeEnd'
     * @private
     */
    const _changeAttribute = (value, attribute, type) => {
        onChange(value, attribute, type);
    };

    /**
     * @description 输入框的值改变
     * @param value
     * @private
     */
    const _changeValue = value => {
        _handleSliderEvent(value, 'mouseup');
    };

    /**
     * @description 得到input输入框的对应最大最小值
     * @param key
     * @param type
     * @private
     */
    const _getLimit = (key, type) => {
        if (!FJUtil.isUndefined(min) && !FJUtil.isUndefined(max)) {
            if (type === 'min') {
                return min;
            } else {
                return max;
            }
        } else {
            if (limitInfo[key]) return limitInfo[key][type];
            else {
                if (type === 'min') {
                    return min;
                } else {
                    return max;
                }
            }
        }
    };

    const _onMouseDown = () => {
        mouseDownHideDropDown && FJDropDownManager.hideAll();
    };

    return (
        <div className={classNames(styles.box, className)} onMouseDown={_onMouseDown}>
            <div className={styles.top}>
                <div className={classNames(styles.name, labelClassName)}>{text}</div>
                <FJValueInput
                    className={styles.input}
                    value={value}
                    changeValue={value => {
                        _changeValue(value, name);
                    }}
                    min={_getLimit(name, 'min')}
                    max={_getLimit(name, 'max')}
                    digits={digits}
                />
            </div>
            <FJSlider
                min={_getLimit(name, 'min')}
                max={_getLimit(name, 'max')}
                value={value}
                className={styles.slider}
                onChange={(value, type) => {
                    _handleSliderEvent(value, type);
                }}
                defaultValue={defaultValue}
            />
        </div>
    );
};

export default FJSliderSet;
